import { LocaleActionTypes, SET_CURRENT_LOCALE, SET_LIST, SET_LIST_LOCALE, SET_MAIN_LOCALE, SET_TRANSLATE_LOCALE } from './actionTypes';
// Types
import { LocaleState } from '../objects/localeState';

const initialState: LocaleState = {
    current_locale: null,
    list: null,
    locales_list: null,
    main_locale: null,
    main_locale_code: 'fr',
    previous_locale: null,
    translate_locale: []
};

export default (state: LocaleState = initialState, action: LocaleActionTypes): LocaleState => {
    switch (action.type) {
        case SET_CURRENT_LOCALE: {
            const translate_locale = state.translate_locale;
            const index = translate_locale.indexOf(action.payload);
            if (index !== -1) {
                translate_locale.splice(index, 1);
            }
            return {...state, current_locale: action.payload, previous_locale: state.current_locale, translate_locale: translate_locale};
        }
        case SET_LIST: {
            const results = action.payload;
            const mainStillAvailable = state.main_locale !== null && results.some(l => l.id === state.main_locale );
            const nextCurrent = mainStillAvailable ? state.main_locale : (results.length > 0 ? results[0].id : null);
            const mainCode = results.find(l => l.id === state.main_locale)?.language_code;
            return {
                ...state,
                list: results,
                current_locale: nextCurrent,
                main_locale_code: mainCode ?? state.main_locale_code
            };
        }
        case SET_MAIN_LOCALE: {
            let main_locale_code = state.main_locale_code;
            if (state.list !== null) {
                state.list.map(locale => {
                    if (locale.id === action.payload) {
                        main_locale_code = locale.language_code;
                    }
                });
            }
            return {...state, current_locale: action.payload, main_locale: action.payload, main_locale_code: main_locale_code};
        }
        case SET_TRANSLATE_LOCALE: {
            return {...state, translate_locale: action.payload};
        }
        case SET_LIST_LOCALE: {
            return { ...state, locales_list: action.payload.results };
        }
        default:
            return state;
    }
};